import React, { useState, useEffect, FC, InputHTMLAttributes } from 'react';

import { Clock } from 'lucide-react';

import { Field, ControlSize } from '../field';
import { Input } from '../input';

import { isValid } from './validate';

interface IProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  disabled?: boolean;
  onTimeChange: (a: string) => void;
  onFocusHandler?: (e: React.FocusEvent<HTMLInputElement>) => void;
  placeholder?: string;
  label?: string;
  error?: string;
  showError?: boolean;
  onBlurHandler?: (e: React.FocusEvent<HTMLInputElement>) => void;
  value: string;
  size: ControlSize;
}

export const TimePickerCustom: FC<IProps> = ({
  disabled,
  onTimeChange,
  onFocusHandler,
  placeholder = '',
  onBlurHandler,
  error,
  showError = true,
  label,
  required,
  value,
  size,
}) => {
  const [time, setTime] = useState<string | null>(null);

  let lastVal = '';
  useEffect(() => {
    if (value) {
      setTime(value);
    }
  }, [value]);

  const onChangeHandler = (val: string) => {
    if (isValid(val)) {
      if (val && !val.includes('0') && Number(val) > 2 && Number(val) < 10) {
        val = `0${val}`;
      }
      if (val.length === 2 && lastVal.length !== 3 && val.indexOf(':') === -1) {
        val = `${val}:`;
      }

      if (val.length === 2 && lastVal.length === 3) {
        val = val.slice(0, 1);
      }

      if (val.length > 5) {
        return false;
      }

      lastVal = val;

      setTime(val);

      if (val.length === 5) {
        onTimeChange(val);
      }
    }
  };

  return (
    <Field size={size} label={label} required={required} error={showError ? error : undefined} invalid={Boolean(error)}>
      <Input
        size={size}
        inputMode="numeric"
        disabled={disabled}
        placeholder={placeholder}
        value={time ?? ''}
        onChange={(e) => onChangeHandler(e.target.value)}
        onFocus={onFocusHandler}
        onBlur={onBlurHandler}
        icon={{ type: 'suffix', icon: <Clock size={20} strokeWidth={1} className="text-ink" aria-hidden /> }}
      />
    </Field>
  );
};
